// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.mjs";

function fromString(status) {
  var match = status.toLowerCase();
  switch (match) {
    case "cancelled" :
        return /* Cancelled */4;
    case "completed" :
        return /* Completed */3;
    case "confirmed" :
        return /* Confirmed */1;
    case "live" :
        return /* Live */2;
    case "searching" :
        return /* Searching */0;
    case "unsuccessful" :
        return /* Unsuccessful */5;
    default:
      return ErrorUtils$Catalyst.raiseError("OrderStatus.res", "Invalid order status", status);
  }
}

function toString(status) {
  switch (status) {
    case /* Searching */0 :
        return "searching";
    case /* Confirmed */1 :
        return "confirmed";
    case /* Live */2 :
        return "live";
    case /* Completed */3 :
        return "completed";
    case /* Cancelled */4 :
        return "cancelled";
    case /* Unsuccessful */5 :
        return "unsuccessful";
    
  }
}

function toDisplayString(status) {
  switch (status) {
    case /* Searching */0 :
        return "Searching";
    case /* Confirmed */1 :
        return "Confirmed";
    case /* Live */2 :
        return "Live";
    case /* Completed */3 :
        return "Completed";
    case /* Cancelled */4 :
        return "Cancelled";
    case /* Unsuccessful */5 :
        return "Unsuccessful";
    
  }
}

export {
  fromString ,
  toString ,
  toDisplayString ,
}
/* No side effect */
